/** Conditional logger — only outputs in development */
const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  error: (...args) => isDev && console.error(...args),
  warn: (...args) => isDev && console.warn(...args),
  log: (...args) => isDev && console.log(...args),
};
